import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  // baseURL: "/api/", // api的base_url
  timeout: 5 * 60 * 1000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  // console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
    // 导出
    const headers = response.headers;
    // console.log("headers:" + JSON.stringify(headers))
    if(headers['content-type'] === 'application/csv;charset=gbk' || headers['content-type'] === 'application/txt;charset=gbk' || headers['content-type'.startsWith("application/vnd")]){
      return response;
    }

    const res = response.data
    if (res.code !== 0) {
      if(res.code === 500 || res.code === 101 || res.code === 102 || res.code === 103
        || res.code === 104 || res.code === 105 || res.code === 105){
        Message({
          message: res.msg,
          type: 'error',
          offset:300,
          duration: 3 * 1000
        })
      }

      // 401:未登录;
      if (res.code === 401||res.code === 403) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    Message({
      message: error.msg,
      type: 'error',
      duration: 3 * 1000,
      offset:300
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js